import { ProviderLayout } from './ProviderLayout';
import { ReviewSection } from '../reviews/ReviewSection';
import { MessageSquare } from 'lucide-react';
import { useAdminAuth } from '../../contexts/AdminAuthContext';

export function ProviderReviews() {
  const { authHeaders } = useAdminAuth();
  return (
    <ProviderLayout>
      <div className="p-4 sm:p-6 md:p-8 w-full">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-white flex items-center gap-2.5">
            <MessageSquare className="w-6 h-6 text-cyan-400" />
            Bewertungen
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Kundenbewertungen für dein Anbieter-Profil. Du kannst auf genehmigte Bewertungen antworten.
          </p>
        </div>
        <ReviewSection hostingId={null} isProvider={true} providerAuthHeaders={authHeaders} />
      </div>
    </ProviderLayout>
  );
}
